import { FC } from 'react'
import styles from './LabelComponent.module.scss'

interface Props {
  label: {
    className: string
    isPermit: boolean
    text: string
    icon: string
    meta: string
  }
  style?: string
}

const LabelComponent: FC<Props> = ({ label, style }: Props): JSX.Element => {
  return (
    <li className={`${styles.container} ${style || styles.label} ${styles[label.className]}`}>
      <img className={styles.icon} src={label.icon} alt={label.meta} height={16} width={16} />
      <div className={styles.labelName}>{label.text}</div>
    </li>
  )
}

export default LabelComponent
